import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import { useMedia } from "react-use";

import { Header } from "@/components/Header";
import { Icon } from "@/components/Icon";
import { ISectionProps, Section } from "@/components/Section";
import { Text } from "@/components/Text";
import { MEDIA_SIZE_SM } from "@/core/media";
import { IContactPerson } from "@/data/consultant-profiles";
import { IOrigin } from "@/data/job-requests";
import { Flex } from "@/eworkitComponents";
import { ContactPerson } from "@/views/components/Contact";
import { BrandedLogo, LogoPlaceholder } from "@/views/components/Logo";

export interface IWorkOrderContactSectionProps extends ISectionProps {
  origin: IOrigin;
  contactPerson: IContactPerson;
}

export const WorkOrderContactSection: FC<IWorkOrderContactSectionProps> = memo(
  ({ origin, contactPerson, ...sectionProps }) => {
    const { t } = useTranslation("session");
    const isSmallScreen = useMedia(MEDIA_SIZE_SM);

    return (
      <Section
        width={12}
        padding={["md", "lg"]}
        innerMargin="md"
        flex
        direction={isSmallScreen ? "column" : "row"}
        borderRadius={!isSmallScreen}
        shadow={isSmallScreen ? "none" : "default"}
        {...sectionProps}>
        <Flex width={isSmallScreen ? 12 : 6} innerMargin="sm" direction="column">
          <Header size="sm" color="black" weight="bold">
            {t("WORK_ORDERS.DETAILS.CONTACT_SECTION.COMPANY_HEADER")}
          </Header>

          <Flex direction={isSmallScreen ? "column" : "row"} innerMargin="md">
            <BrandedLogo src={origin.details.logo} size="xl" placeholder={<LogoPlaceholder size="lg" />} />

            <Flex align="flex-start" innerMargin="sm" direction="column">
              <Flex innerMargin="sm" align="center" margin={[false, false, "xs", false]}>
                <Icon color="grey2" icon="company" size="md" />
                <Text size="md" text={origin.name} />
              </Flex>
            </Flex>
          </Flex>
        </Flex>

        <Flex width={isSmallScreen ? 12 : 6} innerMargin="sm" direction="column">
          <Header size="sm" color="black" weight="bold">
            {t("WORK_ORDERS.DETAILS.CONTACT_SECTION.MANAGER_HEADER")}
          </Header>

          <ContactPerson contactPerson={contactPerson} />
        </Flex>
      </Section>
    );
  },
);
